import ManeuverArrow from '@/components/map/ManeuverArrow.jsx'

/**
 * THE LIVE INSTRUCTION — one line, over the map, at the top where someone walking glances.
 *
 * ⚠️ THE DISTANCE IS RECOMPUTED, NOT READ OFF THE STEP. A step's own distance is fixed at
 * the moment the route was solved, so it holds one number for a whole corridor and then
 * jumps — which is a countdown that does not count down.
 *
 * ⚠️ AND IT IS ANCHORED LEFT ON DESKTOP, FULL WIDTH ON A PHONE. A walker holds the phone
 * low and reads the top of it; a bar that grows from the right corner would put the words
 * somewhere different on every instruction.
 */
export default function WalkInstructionCard({instruction, metres, headline}) {
    if (!instruction) return null

    const turn = instruction.toLowerCase()
    const modifier = turn.includes('left') ? 'left' : turn.includes('right') ? 'right' : 'straight'
    const arrived = instruction === 'Arrived'

    return (
        <div className="pointer-events-none absolute inset-x-4 top-4 z-10 flex items-center gap-3 rounded-2xl bg-[#201E20] px-4 py-3 text-white shadow-[0_4px_20px_rgba(0,0,0,0.35)] md:left-6 md:right-auto md:w-fit md:max-w-[calc(100%-12rem)]">
            <span className="shrink-0">
                <ManeuverArrow type={turn.includes('slight') ? 'slight' : 'turn'} modifier={modifier}/>
            </span>
            <span className="min-w-0 flex-1">
                <span className="block whitespace-nowrap text-lg font-semibold leading-tight max-md:text-base">
                    {arrived ? 'Arrived' : `${formatMetres(metres)} · ${instruction}`}
                </span>
                {headline && <span className="block truncate text-sm opacity-90">{headline}</span>}
            </span>
        </div>
    )
}

/** Metres up close, kilometres once metres stop being a number anyone counts. */
function formatMetres(metres) {
    if (!Number.isFinite(metres)) return ''
    return metres >= 1000 ? `${(metres / 1000).toFixed(1)} km` : `${Math.round(metres)} m`
}

export {WalkInstructionCard}
